export enum AlertView {
    TOAST = "toast",
    EMBEDDED = "embedded",
    STRIPE = "stripe",
}
